<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择Esop"
      width="1000px"
      top="5vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="esops"
        @select="selectEsop"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" @submit.native.prevent>
          <el-form-item label="关键字" prop="filter">
            <el-input v-model.trim="filter.filter" placeholder="请输入" clearable/>
          </el-form-item>
          <!-- <el-form-item label="业务类别" prop="businessTypeName">
            <el-select v-model="filter.businessTypeName" placeholder="请选择业务类别" clearable>
              <el-option label="运控产品" value="运控产品" />
              <el-option label="之山产品" value="之山产品" />
              <el-option label="之山专机" value="之山专机" />
            </el-select>
          </el-form-item> -->
        </el-form>
      </template>
      <!--      <el-table-column prop="esopNo" align="center" label="ESOP编号" width="150"/>-->
      <!--      <el-table-column prop="esopName" align="left" label="ESOP名称"/>-->
      <!--      <el-table-column label="操作" align="center" width="80px" prop="action">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        filter: {
          filter: "",
        },
        columns: [
          {
            title: "编号",
            width: 100,
            key: "esopNo",
            align: "center",
          },
          {
            title: "物料编号",
            width: 160,
            key: "materialNo",
            align: "center",
          },
          {
            title: "规格型号",
            key: "specification",
            align: "center",
          },
          {
            title: "物料名称",
            width: 120,
            key: "materialName",
            align: "center",
          },
          {
            title: "文件状态",
            width: 100,
            key: "fileTypeName",
            align: "center",
          },
          {
            title: "文件类型",
            width: 100,
            key: "statusName",
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      // onSelect(row) {
      //   this.$emit("select", row);
      //   this.dialogVisible = false;
      // },

      selectEsop(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.filter.statusName = this.temp;
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>